<template>
  <div class="container">
    <div class="card">
      <div class="card-content">
        <h5 class="blue-color">{{ $t('views.navbar.support') }}</h5>
      </div>
      <div class="card-content grey lighten-4">
        <p> {{ $t('views.navbar.supportdescription') }} </p>
        <p> <a
          :href="`mailto:${applicationSupport.emailaddress}`"
          target="_top">{{ applicationSupport.emailname}}</a> </p>
      </div>
    </div>
  </div>
</template>

<script>
import AuthenticationService from '../../services/AuthenticationService'
import organisationApi from '../../services/api/OrganisationsApi'
export default {
  data () {
    return {
      currentUser: AuthenticationService.getUser(),
      organisation: null,
      applicationSupport: {
        emailaddress: 'possteam@strukton.com',
        emailname: 'POSS team'
      }
    }
  },
  methods: {
    async getOrganisation () {
      await organisationApi.getOrganisation(this.currentUser.OrganisationId).then(result => {
        this.organisation = result.data
        if (this.organisation !== null) {
          this.applicationSupport.emailaddress = this.organisation.ServiceEmailAdress ? this.organisation.ServiceEmailAdress : 'possteam@strukton.com'
          this.applicationSupport.emailname = this.organisation.ServiceContactName ? this.organisation.ServiceContactName : 'POSS team'
        }
      })
    }
  },
  watch: {
    'currentUser': {
      immediate: true,
      handler: function (val, oldVal) {
        if (this.currentUser !== null) {
          this.getOrganisation()
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/application/support.vue